var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full h-full" },
    [
      _c(
        "GmapMap",
        {
          ref: "map",
          staticClass: "w-full h-full",
          attrs: {
            center: { lat: 10, lng: 10 },
            zoom: _vm.zoom,
            options: _vm.mapOptions
          }
        },
        _vm._l(_vm.markers, function(m, index) {
          return _c("GmapMarker", {
            key: index,
            attrs: {
              icon: { url: "https://liberoo.be/dot.png" },
              position: m,
              clickable: false,
              draggable: false
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }